import * as ResultsDataManage from '@Services/ResultsDataManage';
import { baseParamsForSorting as baseParamsForSortingSelector } from './ResultToolbarSelectors';

// eslint-disable-next-line import/prefer-default-export
export function setSorting(value, order) {
  return (dispatch, getState) => {
    const state = getState();
    const baseParamsForSorting = baseParamsForSortingSelector(state);

    const searchParams = {
      ...baseParamsForSorting,
      order,
      sort: value,
      sortChanged: true,
      limitOrExclude: '',
      resetBreadcrumbs: false,
    };

    // Change state to call new results
    return ResultsDataManage.redirectToResults(searchParams);
  };
}
